import React, { useRef, useEffect } from 'react';

const WidgetChart = ({ chartHTML, isTableChart, rawSqlResponse }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    function onMessage(e) {
      if (e?.data?.type === 'EMBED_HEIGHT' && iframeRef.current) {
        if (isTableChart && e.data.h > 500) {
          iframeRef.current.parentElement.style.overflowY = 'auto';
        }
      }
    }
    
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [isTableChart]);

  return (
    <div className="visualization-container">
      {chartHTML && (
        <>
          <div
            className={`chart-wrapper rounded-lg shadow-sm border border-gray-200 bg-white ${
              isTableChart ? 'resize overflow-hidden' : 'overflow-auto'
            }`}
            style={{ maxHeight: '700px', height: '350px', maxWidth: '100%' }}
          >
            <iframe
              ref={iframeRef}
              src={chartHTML}
              title="Chart"
              className="border-none w-full"
              style={{ display: 'block', backgroundColor: 'white', height: '100%' }}
            />
          </div>
          {rawSqlResponse && (
            <div className="mt-4 p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg text-sm border border-blue-100 shadow-sm">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-1 h-5 bg-primary rounded-full"></div>
                <h4 className="m-0 text-sm font-semibold text-primary">Key Insights</h4>
              </div>
              <div
                className="text-gray-700"
                dangerouslySetInnerHTML={{ __html: rawSqlResponse }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WidgetChart;